import React, { useEffect } from 'react';
import { Breadcrumb, Col, Skeleton } from 'antd';
import { RouteComponentProps } from 'react-router';
import { CommonLayout } from 'common/components/Layouts/CommonLayout';
import { ELayoutSize } from 'common/const/common.const';
import { ERoutesPrivate } from 'common/models/routesModel';
import { ECommonFormType } from 'common/models/commonModel';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import {
  addBitecoinRewardCategory,
  deleteBitecoinRewardCategory,
  getBitecoinRewardCategoryById,
  setBitecoinRewardCategoryModel,
  updateBitecoinRewardCategory,
} from 'app/store/reducers/bitecoin.reducer';
import { CategoryFormSkeleton } from 'entities/Category/components/Skeleton/CategoryFormSkeleton';
import {
  IBitecoinRewardCategoryCreateParams,
  IBitecoinRewardCategoryUpdateParams,
} from 'entities/Bitecoin/Bitecoin.models';
import { BitecoinRewardCategoryForm } from 'entities/Bitecoin/components/BitecoinRewardCategoryForm';

interface IParams {
  id?: string;
}

type AllProps = RouteComponentProps<IParams>;

export const BitecoinRewardCategoryPage: React.FC<AllProps> = ({ match }) => {
  const dispatch = useAppDispatch();
  const { bitecoinRewardCategoryModel, bitecoinRewardCategoryModelLoading } = useAppSelector((state) => state.bitecoin);
  const { params } = match;
  const { id } = params;
  const categoryName = bitecoinRewardCategoryModel?.name;
  const isEdit = !!id;
  const typeForm = isEdit ? ECommonFormType.Update : ECommonFormType.Add;

  const addRewardCategory = (data: IBitecoinRewardCategoryCreateParams) => {
    dispatch(addBitecoinRewardCategory(data));
  };

  const updateRewardCategory = (data: IBitecoinRewardCategoryUpdateParams) => {
    if (id) {
      dispatch(updateBitecoinRewardCategory(id, data));
    }
  };

  const deleteRewardCategory = () => {
    const { params } = match;
    const { id } = params;

    if (id) {
      dispatch(deleteBitecoinRewardCategory(id));
    }
  };

  useEffect(() => {
    const { params } = match;
    const { id } = params;

    if (id) {
      dispatch(getBitecoinRewardCategoryById(id));
    }

    return () => dispatch(setBitecoinRewardCategoryModel(null));
  }, []);

  return (
    <CommonLayout typeLayout={ELayoutSize.Large} classStyle="mt-10 pb-10">
      <Col span={12}>
        <Breadcrumb className="fs-sm font-weight-5 font-family__default mb-8">
          <Breadcrumb.Item href={`${ERoutesPrivate.Bitecoin}?tab=${EBitecoinPageTabKeys.RewardCategories}`}>
            Category list
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {isEdit ? (
              !bitecoinRewardCategoryModelLoading ? (
                categoryName
              ) : (
                <Skeleton.Input active style={{ width: '200px' }} size="small" />
              )
            ) : (
              'Add new category'
            )}
          </Breadcrumb.Item>
        </Breadcrumb>
        {!bitecoinRewardCategoryModelLoading ? (
          <BitecoinRewardCategoryForm
            typeForm={typeForm}
            createRewardCategory={addRewardCategory}
            updateRewardCategory={updateRewardCategory}
            deleteRewardCategory={deleteRewardCategory}
          />
        ) : (
          <CategoryFormSkeleton typeForm={typeForm} />
        )}
      </Col>
    </CommonLayout>
  );
};
